"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoriesTemplate = void 0;
const lit_html_1 = require("lit-html");
/**
 * Возвращает шаблон категорий для страницы поиска
 */
function getCategoriesTemplate(container, categories, translations) {
    function toggleSearchCategories() {
        container.classList.toggle('search-open');
    }
    return (0, lit_html_1.html) `
        <div class="search-categories__list">
            ${categories.map((category) => (0, lit_html_1.html) `
                <a href="${category.url}" class="search-categories__item">${category.label}</a>
            `)}
        </div>
        <a href="/catalog" class="header-nav__item header-item-down" >  
            <span class="search__view-txt">${translations.instant('searchPageShowTagsBtn')}</span>
<!--            <span class="search__hide-txt">${translations.instant('searchPageHideTagsBtn')}</span>-->
        </a>
    `;
}
exports.getCategoriesTemplate = getCategoriesTemplate;
